import { isNil, uniq } from 'lodash'
import { AxiosRequestConfig } from 'axios'

import { Feedback, Post } from 'lib/_types'
import {
  pathApiFeedbacks,
  pathApiGroupsJoinedStatuses,
  pathApiThreadsJoinedStatuses,
} from 'lib/paths'

export const mapPostGroupStatuses = async ({
  baseQuery,
  posts,
  isLoggedIn,
}: {
  baseQuery: (args: AxiosRequestConfig) => Promise<any>
  posts: Array<Post>
  isLoggedIn?: boolean
}) => {
  if (!isLoggedIn) {
    return posts
  }

  const shareableIds = uniq(
    posts
      ?.filter?.(
        (x) =>
          x?.post_type == 'shareable_group' && !isNil(x?.shareable?.group?.id)
      )
      ?.map?.((x) => x?.shareable?.group?.id)
  )

  if (shareableIds?.length > 0) {
    const joinedStatusesRes = await baseQuery({
      url: pathApiGroupsJoinedStatuses,
      params: {
        ids: shareableIds,
      },
    })

    const joinedStatusesResData = joinedStatusesRes?.data

    posts = posts?.map?.((x) => {
      const shareableId = x?.shareable?.group?.id

      if (shareableId in joinedStatusesResData) {
        return {
          ...x,
          _groupRelationship: joinedStatusesResData?.[shareableId],
        }
      }

      return x
    })
  }

  return posts
}

export const mapPostThreadStatuses = async ({
  isLoggedIn,
  posts,
  baseQuery,
}: {
  baseQuery: (args: AxiosRequestConfig) => Promise<any>
  posts: Array<Post>
  isLoggedIn: boolean
}) => {
  if (!isLoggedIn) {
    return posts
  }

  const shareableIds = uniq(
    posts
      ?.filter?.(
        (x) =>
          x?.post_type == 'shareable_thread' &&
          !isNil(x?.shareable?.['posts/thread']?.id)
      )
      ?.map?.((x) => x?.shareable?.['posts/thread']?.id)
  )

  if (shareableIds?.length > 0) {
    const joinedStatusesRes = await baseQuery({
      url: pathApiThreadsJoinedStatuses,
      params: {
        ids: shareableIds,
      },
    })

    const joinedStatusesResData = joinedStatusesRes?.data

    posts = posts?.map?.((x) => {
      const shareableId = x?.shareable?.['posts/thread']?.id

      if (shareableId in joinedStatusesResData) {
        return {
          ...x,
          _threadRelationship: joinedStatusesResData?.[shareableId],
        }
      }

      return x
    })
  }

  return posts
}

export const mapPostFeedbacks = async ({
  posts,
  baseQuery,
}: {
  baseQuery: (args: AxiosRequestConfig) => Promise<any>
  posts: Array<Post>
}) => {
  const postIds = uniq(posts?.map?.((x) => x?.id))

  if (postIds?.length > 0) {
    const feedbacksRes = await baseQuery({
      url: pathApiFeedbacks,
      params: {
        post_ids: postIds,
      },
    })

    posts = posts?.map?.((x) => {
      const feedback = feedbacksRes?.data?.find?.(
        (y: Feedback) => x?.id == y?.post_id
      )

      if (!isNil(feedback)) {
        return {
          ...x,
          _feedback: feedback?.feedback,
        }
      }

      return x
    })
  }

  return posts
}
